import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "controls-title" }
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "controls-group zoom-slider-group" }
const _hoisted_4 = ["value", "title"]
const _hoisted_5 = { class: "zoom-display" }
const _hoisted_6 = { class: "controls-group" }
const _hoisted_7 = ["title"]
const _hoisted_8 = ["title"]
const _hoisted_9 = { class: "controls-group" }
const _hoisted_10 = ["title"]
const _hoisted_11 = ["title"]
const _hoisted_12 = ["title"]

import { ref, onMounted, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';

interface Props {
  zoom: number;
  isVisible?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AnnotationControls',
  props: {
    zoom: {},
    isVisible: { type: Boolean, default: true }
  },
  emits: ["zoom-in", "zoom-out", "zoom-reset", "fit-to-screen", "fit-to-width", "fit-to-page", "actual-size", "zoom-to", "close"],
  setup(__props: any, { emit: __emit }) {

// @ts-ignore


const emit = __emit;

const { t } = useI18n();

// Position state
const position = ref({ x: 0, y: 0 });
const isDragging = ref(false);
const dragOffset = ref({ x: 0, y: 0 });

// Initialize position on mount
onMounted(() => {
  // Default position: bottom-right with some padding
  position.value = {
    x: window.innerWidth - 220,
    y: window.innerHeight - 380
  };
});

const handleZoomSlider = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const zoomPercent = parseInt(target.value);
  const zoomValue = zoomPercent / 100;
  emit('zoom-to', zoomValue);
};

// Drag functionality
const startDrag = (event: MouseEvent) => {
  isDragging.value = true;
  dragOffset.value = {
    x: event.clientX - position.value.x,
    y: event.clientY - position.value.y
  };
  
  document.addEventListener('mousemove', onDrag);
  document.addEventListener('mouseup', stopDrag);
  event.preventDefault();
};

const onDrag = (event: MouseEvent) => {
  if (!isDragging.value) return;
  
  position.value = {
    x: event.clientX - dragOffset.value.x,
    y: event.clientY - dragOffset.value.y
  };
};

const stopDrag = () => {
  isDragging.value = false;
  document.removeEventListener('mousemove', onDrag);
  document.removeEventListener('mouseup', stopDrag);
};

onUnmounted(() => {
  document.removeEventListener('mousemove', onDrag);
  document.removeEventListener('mouseup', stopDrag);
});

return (_ctx: any,_cache: any) => {
  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "annotation-controls",
        style: _normalizeStyle({ left: `${position.value.x}px`, top: `${position.value.y}px` })
      }, [
        _createElementVNode("div", {
          class: "controls-header",
          onMousedown: startDrag
        }, [
          _createElementVNode("span", _hoisted_1, [
            _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-search" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('annotation.zoom')), 1)
          ]),
          _createElementVNode("button", {
            class: "close-btn",
            title: _ctx.$t('common.close'),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, [...(_cache[7] || (_cache[7] = [
            _createElementVNode("i", { class: "fas fa-times" }, null, -1)
          ]))], 8, _hoisted_2)
        ], 32),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("input", {
            type: "range",
            class: "zoom-slider",
            min: "25",
            max: "400",
            value: Math.round(_ctx.zoom * 100),
            onInput: handleZoomSlider,
            title: `${Math.round(_ctx.zoom * 100)}%`
          }, null, 40, _hoisted_4),
          _createElementVNode("span", _hoisted_5, _toDisplayString(Math.round(_ctx.zoom * 100)) + "%", 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "control-btn",
            title: _ctx.$t('annotation.zoomIn'),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('zoom-in')))
          }, [...(_cache[8] || (_cache[8] = [
            _createElementVNode("i", { class: "fas fa-search-plus" }, null, -1)
          ]))], 8, _hoisted_7),
          _createElementVNode("button", {
            class: "control-btn",
            title: _ctx.$t('annotation.zoomOut'),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('zoom-out')))
          }, [...(_cache[9] || (_cache[9] = [
            _createElementVNode("i", { class: "fas fa-search-minus" }, null, -1)
          ]))], 8, _hoisted_8)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "control-btn",
            title: _ctx.$t('annotation.fitToWidth'),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('fit-to-width')))
          }, [...(_cache[10] || (_cache[10] = [
            _createElementVNode("i", { class: "fas fa-arrows-alt-h" }, null, -1)
          ]))], 8, _hoisted_10),
          _createElementVNode("button", {
            class: "control-btn",
            title: _ctx.$t('annotation.fitToPage'),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('fit-to-page')))
          }, [...(_cache[11] || (_cache[11] = [
            _createElementVNode("i", { class: "fas fa-expand-arrows-alt" }, null, -1)
          ]))], 8, _hoisted_11),
          _createElementVNode("button", {
            class: "control-btn",
            title: _ctx.$t('annotation.actualSize'),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('actual-size')))
          }, [...(_cache[12] || (_cache[12] = [
            _createElementVNode("i", { class: "fas fa-compress-arrows-alt" }, null, -1)
          ]))], 8, _hoisted_12)
        ])
      ], 4))
    : _createCommentVNode("", true)
}
}

})